import { type FC, useEffect } from 'react'

import { useDeviceDetectorContext } from '../../../device-detector/context/deviceDetectorContext'
import { useBuildAddToCartParams } from '../../../product-page/components/ProductBuyBox/ProductAddToCartGroup/ProductAddToCartCta/useBuildAddToCartParams'
import { ProductBuyBoxSticky } from '../../../product-page/components/ProductBuyBox/ProductBuyBoxSticky'
import { useProductPageContext } from '../../../product-page/components/productPageContext'
import { useGetExperimentForTenant } from '../../hooks/useGetExperimentForTenant'
import { EXPERIMENT_NAME_STICKY_BUY_BOX } from '../../model/EXPERIMENT_NAME_PER_TENANT'
import { EXPERIMENT_VARIATION } from '../../model/EXPERIMENT_VARIATION'
import { useExperimentsContext } from '../ExperimentsContext'

import { ExperimentStickyBuyBoxV1 } from './ExperimentStickyBuyBoxV1'
import { ExperimentStickyBuyBoxV1Mobile } from './ExperimentStickyBuyBoxV1Mobile'
import { ExperimentStickyBuyBoxV2 } from './ExperimentStickyBuyBoxV2'
import { ExperimentStickyBuyBoxV2Mobile } from './ExperimentStickyBuyBoxV2Mobile'
import { ExperimentStickyBuyBoxV3 } from './ExperimentStickyBuyBoxV3'
import { ExperimentStickyBuyBoxV3Mobile } from './ExperimentStickyBuyBoxV3Mobile'

export const ExperimentStickyBuyBox: FC = () => {
  const stickyBuyBoxExperiment = useGetExperimentForTenant(
    EXPERIMENT_NAME_STICKY_BUY_BOX,
  )

  const { addExperimentKeysForActivation } = useExperimentsContext()
  const { isEnabled, name: experimentName, variant } = stickyBuyBoxExperiment
  const { disableCta } = useBuildAddToCartParams()
  const { product } = useProductPageContext()

  useEffect(() => {
    if (isEnabled) {
      addExperimentKeysForActivation(experimentName)
    }
  }, [addExperimentKeysForActivation, experimentName, isEnabled])
  const { isMobile } = useDeviceDetectorContext()

  return (
    <>
      {(!isEnabled || variant === EXPERIMENT_VARIATION.DEFAULT) && isMobile ? (
        <div className="relative z-10" data-clientside-hook="stickyBuyBox">
          <ProductBuyBoxSticky />
        </div>
      ) : null}
      {isEnabled && variant === EXPERIMENT_VARIATION.V1 ? (
        <div className="relative z-10" data-clientside-hook="stickyBuyBox">
          <ExperimentStickyBuyBoxV1 disableCta={disableCta} product={product} />
          <ExperimentStickyBuyBoxV1Mobile
            disableCta={disableCta}
            product={product}
          />
        </div>
      ) : null}
      {isEnabled && variant === EXPERIMENT_VARIATION.V2 ? (
        <div className="relative z-10" data-clientside-hook="stickyBuyBox">
          <ExperimentStickyBuyBoxV2 disableCta={disableCta} product={product} />
          <ExperimentStickyBuyBoxV2Mobile
            disableCta={disableCta}
            product={product}
          />
        </div>
      ) : null}
      {isEnabled && variant === EXPERIMENT_VARIATION.V3 ? (
        <div className="relative z-10" data-clientside-hook="stickyBuyBox">
          <ExperimentStickyBuyBoxV3 disableCta={disableCta} product={product} />
          <ExperimentStickyBuyBoxV3Mobile disableCta={disableCta} />
        </div>
      ) : null}
    </>
  )
}
